import { render } from "./CompleteReceivedSendOuts.vue?vue&type=template&id=10fafdc2"
import script from "./CompleteReceivedSendOuts.vue?vue&type=script&lang=js"
export * from "./CompleteReceivedSendOuts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/sendOuts/CompleteReceivedSendOuts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10fafdc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10fafdc2', __exports__)) {
    console.log('reload')
    api.reload('10fafdc2', __exports__)
  }
  
  module.hot.accept("./CompleteReceivedSendOuts.vue?vue&type=template&id=10fafdc2", () => {
    console.log('re-render')
    api.rerender('10fafdc2', render)
  })

}


export default __exports__